import React from "react";
import {executeQuery} from "../../requests/executeQuery";
import {formatName} from "../../utils";
import order from './order';
import {STRIVE_AGENT_PIPELINE_DETAILS} from '../../consts/queries';
import {getData} from "../../requests/CRUD";
import PipelineDetails from "../PipelineDetails/PipelineDetails";
import {proposal, active, negotiation, underContract, closed, closedYTD, closedHistorical} from "../PipelineDetails/PipelineDetails";
import {TEAM} from "../../consts/tables";

export default class AgentPipelineDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [proposal]: {
                    name: 'Proposals',
                    data: [],
                    total: {},
                },
                [active]: {
                    name: 'Active Listings',
                    data: [],
                    total: {},
                },
                [negotiation]: {
                    name: 'Neg/Under Contract',
                    data: [],
                    total: {},
                },
                [closedYTD]: {
                    name: 'Closed - YTD',
                    data: [],
                    total: {},
                },
                [closedHistorical]: {
                    name: 'Closed - Historical',
                    data: [],
                    total: {},
                },
            },
            agentName: '',
            loading: true,
        };
    }

    static createOptions({id, status1, status2, isYtd = 0, orderBy}) {
        return {
            param: {
                AGENT_ID: id,
                STATUS_1: status1,
                STATUS_2: status2 ? status2 : 'NOMATCH',
                IS_YTD: isYtd
            },
            order: order(orderBy),
        };
    }

    buildTables(res) {
        const tables = {...this.state.tables};
        tables[proposal] = AgentPipelineDetails.buildTable(proposal, tables[proposal], res[0].data);
        tables[active] = AgentPipelineDetails.buildTable(active, tables[active], res[1].data);
        tables[negotiation] = AgentPipelineDetails.buildTable(negotiation, tables[negotiation], res[2].data);
        tables[closedYTD] = AgentPipelineDetails.buildTable(closedYTD, tables[closedYTD], res[3].data);
        tables[closedHistorical] = AgentPipelineDetails.buildTable(closedHistorical, tables[closedHistorical], res[4].data);
        this.setState({tables});
    }

    fetch(id) {
        const proposalOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: proposal,
            orderBy: 'DATE_CREATED.asc'
        });
        const activeOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: active,
            orderBy: 'LISTING_DATE.asc'
        });
        const negotiationOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: negotiation,
            status2: underContract,
            orderBy: 'STATUS.asc'
        });
        const closedYtdOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: closed,
            isYtd: 1,
            orderBy: 'CLOSE_OF_ESCROW.asc'
        });
        const closedHistoricalOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: closed,
            orderBy: 'CLOSE_OF_ESCROW.desc'
        });

        const requests = [
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: proposalOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: activeOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: negotiationOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: closedYtdOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: closedHistoricalOptions}),
        ];

        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            requests.push(getData({tableCode: TEAM, options}));
        }

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data) &&
                res[3] && res[3].success && Array.isArray(res[3].data) &&
                res[4] && res[4].success && Array.isArray(res[4].data) &&
                (!res[5] || res[5] && res[5].success && Array.isArray(res[5].data))) {
                if (res[5]) {
                    agentName = formatName(res[5].data[0]);
                }
                this.setState({agentName}, () => this.buildTables(res));
            }
            this.setState({loading: false});
        });
    }

    componentDidMount() {
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        if (id) {
            this.fetch(id);
            return;
        }
        this.setState({loading: false});
    }
}